import React from "react";
import { Redirect } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Locations

import Locations from "../pages/Locations";
import AddLocation from "../pages/Locations/AddLocation";
import LocationDetail from "../pages/Locations/LocationDetail";
import EditLocation from "../pages/Locations/EditLocation";

//  Brands
import Brands  from "../pages/Vehicles/Brands/index"
import AddBrands  from "../pages/Vehicles/Brands/AddBrands"
import EditBrands from "../pages/Vehicles/Brands/EditBrand"

//  Vehicles
import Vehicles  from "../pages/Vehicles/Vehicles/index"
import AddVehicles  from "../pages/Vehicles/Vehicles/AddVehicles"
import EditVehicles  from "../pages/Vehicles/Vehicles/EditVehicles"
import VehicleDetail from "../pages/Vehicles/Vehicles/VehicleDetail"

// Hotels
import Hotels from "../pages/Hotels/index";
import AddHotels from "../pages/Hotels/AddHotel";
import AddHotelPricing from "../pages/Hotels/AddHotelPricing"
import HotelDetail from "../pages/Hotels/HotelDetail"
import EditHotel from "../pages/Hotels/EditHotel"

// Activities
import Activities from "../pages/Activities";
import AddActivity from "../pages/Activities/AddActivity"
import ActivityDetail from "../pages/Activities/ActivityDetail"
import AddPricing from "../pages/Activities/AddPricing"
import EditActivity from "../pages/Activities/EditActivity";
import EditPricing from "../pages/Activities/EditPricing";

// Itineraries
import Itineraries from "../pages/Itinerary";
import Newitinerary from "../pages/Itinerary/Newitinerary";
import ItineraryDetail from "../pages/Itinerary/ItineraryDetail";
import PaymentDetail from "../pages/Itinerary/PaymentDetail";
import Timeline from "../pages/Itinerary/Timeline";
import DailyPlan from "../pages/Itinerary/DailyPlan";
import ItineraryFooter from "../pages/Itinerary/ItineraryFooter";


// Templates
import Templates from "../pages/Templates";
import NewTemplate from "../pages/Templates/NewTemplate";
import TemplateDetail from "../pages/Templates/TemplateDetail";

// Invoice

import Invoice from "../pages/Invoice";
import AddInvoice from "../pages/Invoice/NewInvoice";
import InvoicePreview from "../pages/Invoice/InvoicePreview";

// CMS

import Signature from "../pages/CMS/Signature/Index";
import AddSignature from "../pages/CMS/Signature/AddSignature";
import InclusitionExclusition from "../pages/CMS/InclusitionExclusition";
import Details from "../pages/CMS/InclusitionExclusition/Details";
import TermsConditions from "../pages/CMS/TermsConditions";
import TermsConditionsDetail from "../pages/CMS/TermsConditions/TermsConditionsDetail";
import Payments from "../pages/CMS/Payments";

// Users
import Users from "../pages/Customers/index"
import AddUser from "../pages/Customers/AddUser";
import Profile from "../pages/Customers/Profile";
import UpdateUser from "../pages/Customers/UpdateUser";

// Payments

import ItinerariesPayments from "../pages/Payments";


//  Utility
import Error404 from "../pages/Utility/Error404";

import Maintenance from "../pages/Utility/Maintenance";

// 
import Countries from "../pages/Settings/Country";
import EditCountry from "../pages/Settings/Country/EditCountry";
import EditState from "../pages/Settings/Country/EditState";
import AddCountry from "../pages/Settings/Country/AddCountry";
import AddState from "../pages/Settings/Country/AddState";
import AddDistrict from "../pages/Settings/Country/AddDistrict";

// Permissions 

import UserRoles from "../pages/Settings/UserRoles";
import PermissionGroups from "../pages/Settings/PermissionGroups";

import PDF from "../pages/PDF";
import { ClassComponent } from "../pages/PDF/ClassComponent";



const authProtectedRoutes = [
	{ path: "/users", component: Users },
	{ path: "/user-detail/:id", component: UpdateUser}, 
	{ path: "/profile", component: Profile },
	{ path: "/add-user", component: AddUser },

	{ path: "/brands", component: Brands },
	{ path: "/new-brand", component: AddBrands },
	{ path: "/edit-brand/:id", component: EditBrands },

	{ path: "/vehicles", component: Vehicles },
	{ path: "/new-vehicle", component: AddVehicles },
	{ path: "/edit-vehicle/:id", component: EditVehicles },

	{ path: "/hotels", component: Hotels },
	{ path: "/new-hotels", component: AddHotels },
	{ path: "/hotel-pricing/:id", component: AddHotelPricing },
	{ path: "/edit-hotel/:id", component: EditHotel },

	{ path: "/activities", component: Activities },
	{ path: "/new-activity", component: AddActivity },
	{ path: "/activity-pricing/:id", component: AddPricing },
	{ path: "/edit-activity/:id", component: EditActivity },
	{ path: "/edit-activity-pricing/:id", component: EditPricing },

	// { path: "/itineraries", component: Itineraries },
	{ path: "/itineraries", exact: true, component: Itineraries },
{ path: "/itineraries/page/:pageNumber", component: Itineraries },

	{ path: "/new-itinerary", component: Newitinerary },
	{ path: "/itinerary-detail/:id", component: ItineraryDetail },
	{ path: "/itinerary-payment-detail/:id", component: PaymentDetail },
	{ path: "/itinerary-daily-plan/:id" , component: DailyPlan },
	{ path: "/itinerary-terms-&-condition/:id" , component: ItineraryFooter },


	{ path: "/templates", component: Templates },
	{ path: "/new-template", component: NewTemplate },
	{ path: "/template-detail/:id", component: TemplateDetail },


	{ path: "/invoices/:id", component: Invoice },
	{ path: "/new-invoice/:id", component: AddInvoice },
	
	{ path: "/signatures", component: Signature },
	{ path: "/new-signature", component: AddSignature },

	{ path: "/inclusitions-exclusitions", component: InclusitionExclusition },
	{ path: "/inclusitions-exclusitions-detail/:id/:name", component: Details },

	{ path: "/terms-and-conditions", component: TermsConditions },
	{ path: "/terms-and-conditions-detail/:id/:name", component: TermsConditionsDetail },

	{ path: "/payments", component: Payments },


	{ path: "/itinerary-payments", component: ItinerariesPayments },


	{ path: "/manage-countries", component: Countries },
	{ path: "/country/:id", component: EditCountry },
	{ path: "/state/:id", component: EditState },
	// { path: "/district/:id", component: EditCountry },
	{ path: "/new-country", component: AddCountry },
	{ path: "/new-state/:id", component: AddState },
	{ path: "/new-district/:id", component: AddDistrict },



	{ path: "/Permissions", component: UserRoles },
	{ path: "/permission-groups", component: PermissionGroups },






	{ path: "/locations", component: Locations },
	{ path: "/new-location", component: AddLocation },
	
	{ path: "/edit-location/:id", component: EditLocation },
	{ path: "/dashboard", component: Dashboard },
	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: () => <Redirect to="/dashboard" /> }
];

const publicRoutes = [
	{ path: "/logout", component: Logout },
	{ path: "/login", component: Login },
	{ path: "/pdf", component: PDF },
	{ path: "/component-to-print", component: ClassComponent },
	{ path: "/itinerary/:id/:name" , component: Timeline },
	{ path: "/itinerary/:id" , component: Timeline },
	{ path: "/invoice-preview/:id", component: InvoicePreview },
	{ path: "/404" , component: Error404 },
	{ path: "/maintenance" , component: Maintenance },

	{ path: "/vehicle/:id", component: VehicleDetail },
	{ path: "/location/:id", component: LocationDetail },
	{ path: "/hotel/:id", component: HotelDetail },
	{ path: "/activity/:id", component: ActivityDetail },

];

export { authProtectedRoutes, publicRoutes };
